import { withInstall } from '@element-plus/utils'
import Autocomplete from './src/autocomplete.vue'

export const ElAutocomplete = withInstall(Autocomplete)

export default ElAutocomplete

export * from './src/autocomplete'
